import { create } from "zustand";

interface KnowledgeBaseStore {
	isOpen: boolean;
	tags: string[];
	/**
	 * Edge the sidebar slides in from. Defaults to "right". Pass "left" when
	 * opening it alongside another right-side sheet (e.g. annotating filters
	 * that are already rendered in the filter sidebar) so the two sit
	 * side by side instead of overlapping.
	 */
	side: "left" | "right";
	openKnowledgeBase: (tags: string[], side?: "left" | "right") => void;
	closeKnowledgeBase: () => void;
}

/**
 * Zustand store for managing knowledge base sidebar state.
 *
 * Usage:
 * const { isOpen, tags, openKnowledgeBase, closeKnowledgeBase } = useKnowledgeBaseStore();
 *
 * // Open sidebar with specific tags
 * openKnowledgeBase(["booking-type"]);
 *
 * // Close sidebar
 * closeKnowledgeBase();
 */
export const useKnowledgeBaseStore = create<KnowledgeBaseStore>((set) => ({
	isOpen: false,
	tags: [],
	side: "right",
	openKnowledgeBase: (tags: string[], side: "left" | "right" = "right") =>
		set({
			isOpen: true,
			tags,
			side,
		}),
	closeKnowledgeBase: () =>
		set({
			isOpen: false,
			tags: [],
			side: "right",
		}),
}));
